import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from './snitem';
import * as moment from 'moment';

@RegisterItem()
export class SNMessage extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNMessage';
    }

    get status(): string {
        return (this.getProperty('status') === null) ? 'none' : this.getProperty('status');
    }

    get text(): string {
        return this.getProperty('text');
    }

    get sender(): string {
        return this.getProperty('username');
    }

    get receiver(): string {
        return this.getProperty('receivername');
    }

    get date(): Date {
        return this.createddate;
    }

    get dateAsString(): string {
        return moment(this.date).format('DD/MM/YYYY HH:mm');
    }

    public clone(): any {
        return new SNMessage();
    }
}

